/*
 ** PRODUCT SUBNAV
 ** SCROLL TO SECTION
 */
const product_section_obs = document.querySelectorAll(".product-section--item");
const sub_nav_button = Array.from(
  document.querySelectorAll(".product-section--subnav-item-button")
);

const getCurrentSubNavBtn = () => {
  const current_btn = document.querySelector(
    ".product-section--subnav-item-button.current-selection"
  );
  return current_btn;
};

const getCurrentProdSection = () => {
  const current_section = document.querySelector(
    ".product-section--item.current-selection"
  );
  if (current_section) return current_section;
  else return null;
};

sub_nav_button.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    let btn_handle = btn.dataset.handle;
    let section_item = document.querySelector(
      ".product-section--item[data-handle='" + btn_handle + "']"
    );

    if (window.innerWidth <= 749) {
      window.scrollTo({
        behavior: "smooth",
        top:
          section_item.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          78,
      });
    } else {
      const mobile_body = document.querySelector(".homepage-mobile-body");
      const mobile_body_inner = document.querySelector(
        ".homepage-mobile-body-inner"
      );

      mobile_body_inner.scrollTo({
        top:
          section_item.getBoundingClientRect().top -
          document.getElementById("MainContent").getBoundingClientRect().top -
          34,
      });

      /*section_item.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });*/
    }

    let subnav_btn = document.querySelector(
      'button[data-handle="' + btn_handle + '"]'
    );

    updateSubNavClass(subnav_btn, section_item);
  });
});

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting >= 0.25) {
        let section_handle = entry.target.dataset.handle;
        let subnav_btn = document.querySelector(
          'button[data-handle="' + section_handle + '"]'
        );

        updateSubNavClass(subnav_btn);
      }
    });
  },
  { threshold: 0.25 }
); // Adjust threshold as needed

product_section_obs.forEach((section) => {
  //observer.observe(section);
});

/*
 ** PRODUCT BUY INFO
 ** VARIANT OPTIONS MODAL
 */

const variants_modal_trigger = Array.from(
  document.querySelectorAll(".product-variant-modal-nav-trigger")
);
const variants_modal = document.querySelector(".variant-selects-modal");

const product_page_container = document.querySelector(
  ".product__media-wrapper"
);

function updateSubNavClass(subnav_btn, section_item) {
  let current_btn = getCurrentSubNavBtn();
  let current_section = getCurrentProdSection();

  if (current_btn) current_btn.classList.remove("current-selection");
  if (current_section) current_section.classList.remove("current-selection");

  if (!subnav_btn.classList.contains("current-selection")) {
    subnav_btn.classList.add("current-selection");
  }

  if (!section_item.classList.contains("current-selection")) {
    section_item.classList.add("current-selection");
  }
}

variants_modal_trigger.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    let data_handle = btn.dataset.handle;
    let active_fieldset = variants_modal.querySelector("fieldset.show");
    let selected_fieldset = variants_modal.querySelector(
      'fieldset[data-handle="' + data_handle + '"]'
    );

    if (variants_modal.classList.contains("show")) {
      if (
        data_handle &&
        active_fieldset &&
        data_handle != active_fieldset.dataset.handle
      ) {
        active_fieldset.classList.remove("show");
        selected_fieldset.classList.add("show");
      } else {
        body.classList.remove("modal-open");
        variants_modal.classList.remove("show");
        active_fieldset.classList.remove("show");
      }
    } else {
      body.classList.add("modal-open");
      variants_modal.classList.add("show");
      selected_fieldset.classList.add("show");
    }
  });
});

document.addEventListener("readystatechange", (event) => {
  if (event.target.readyState === "complete") {
    const quote_overlay = document.querySelector(".pdp-quote-overlay");

    if (quote_overlay) {
      setTimeout(() => {
        quote_overlay.classList.remove("show");
        body.classList.remove("modal-open");
      }, "2500");
    } else {
      body.classList.remove("modal-open");
    }
  }
});

/*
 ** PRODUCT
 ** DETAILS SLIDER
 */

const product_details = document.getElementById("product-section--detail");

if (product_details) {
  const slider_arrow = product_details.querySelectorAll(".glide__arrow");
  const slider = document.getElementById("glide-slider-details");

  const config = {
    childList: true, // Observe direct children additions/removals
    subtree: true, // Observe all descendants, not just direct children
    attributes: true, // Observe attribute changes
    attributeFilter: ["class"], // Only observe changes to the 'class' attribute
  };

  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (
        mutation.target.className == "glide__slide glide__slide--active" &&
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        setDetailCopy();
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(slider, config);

  slider_arrow.forEach((arrow) => {
    arrow.addEventListener("click", function () {
      setDetailCopy();
    });
  });

  function setDetailCopy() {
    const slider_copy = product_details.querySelectorAll(
      ".product-section__description"
    );

    if (window.active_slide != undefined) {
      let active_slide = window.active_slide;
      let active_slide_index = active_slide?.split("_");

      if (active_slide_index && active_slide_index[0] == "details") {
        slider_copy.forEach((copy) => {
          copy.classList.remove("active");
          if (copy.dataset.index == active_slide_index[1]) {
            copy.classList.add("active");
          }
        });
      }
    }
  }
}
